import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import ImageSplitter from '../../components/ImageSplitter';

const SplitterPage: React.FC = () => (
  <ToolLayout
    title="Image Splitter - Split for Instagram Grid | AllTools"
    description="Split images into grid pieces for Instagram and social media. Multiple grid options. Free tool."
    canonicalPath="/image-splitter"
  >
    <ImageSplitter />
  </ToolLayout>
);

export default SplitterPage;
